export default __webpack_public_path__ + "static/media/sleeping-icon.9e4476f8.png";